module.exports = __webpack_public_path__ + "static/img/图片11.031583aa.png";